import React, { useState, useEffect } from "react";
import { Row, Col, Input, Checkbox, message, Button } from "antd";
import DownArrow from "../../../Assets/downArrowIcon.svg";
import CancelIcon from "../../../Assets/cancelIcon.svg";

import API_MANAGER from "../../../API";
import { ReloadOutlined } from "@ant-design/icons";
const CheckboxGroup = Checkbox.Group;

function SearchListItem({ item, setFilters, filters }) {
  const [expand, setExpand] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState(null);
  const [selectedListCount, setSelectedListCount] = useState(0);
  const [selectedList, setSelectedList] = useState(0);
  
  // Update selected count when filters change
  useEffect(() => {
    if (item?.value === "STATE") {
      const locationStorageKey = `${item?.label}_locations`;
      // Use ||| separator to avoid conflicts with commas in location names
      const selectedLocations = filters[locationStorageKey] 
        ? filters[locationStorageKey].split("|||").filter(Boolean)
        : [];
      setSelectedListCount(selectedLocations.length);
    } else {
      const selectedValues = filters[item?.label]?.split(",") ?? [];
      setSelectedListCount(selectedValues.filter(Boolean).length);
    }
  }, [filters, item?.label, item?.value]);
  const getData = async () => {
    try {
      if (item?.value === "CITIZENSHIP") {
        setData(item?.options);
      } else if (item?.value === "STATE") {
        // Use new candidate locations API for location/state
        const response = await API_MANAGER.getCandidateLocations();
        const locations = response?.data?.data || [];
        
        // Helper function to extract state name from location (for filter value)
        const extractStateName = (location) => {
          if (!location) return null;
          
          // If location is an object with state field
          if (typeof location === 'object') {
            // Try structured state field first
            if (location.state?.name) return location.state.name;
            if (location.state) {
              // If state is a string, return it
              if (typeof location.state === 'string') return location.state;
              // If state is an object with name
              if (location.state.name) return location.state.name;
            }
            // If location has a name field that's a string like "Aspley Queensland 4034"
            if (location.name && typeof location.name === 'string') {
              return extractStateFromString(location.name);
            }
            return null;
          }
          
          // If location is a string like "Aspley Queensland 4034"
          if (typeof location === 'string') {
            return extractStateFromString(location);
          }
          
          return null;
        };
        
        // Extract state from string format "Suburb State PostalCode"
        const extractStateFromString = (locationString) => {
          if (!locationString || typeof locationString !== 'string') return null;
          
          // List of Australian states (full names)
          const stateMap = {
            'nsw': 'New South Wales (NSW)',
            'new south wales': 'New South Wales (NSW)',
            'vic': 'Victoria (VIC)',
            'victoria': 'Victoria (VIC)',
            'qld': 'Queensland (QLD)',
            'queensland': 'Queensland (QLD)',
            'wa': 'Western Australia (WA)',
            'western australia': 'Western Australia (WA)',
            'sa': 'South Australia (SA)',
            'south australia': 'South Australia (SA)',
            'tas': 'Tasmania (TAS)',
            'tasmania': 'Tasmania (TAS)',
            'act': 'Australian Capital Territory (ACT)',
            'australian capital territory': 'Australian Capital Territory (ACT)',
            'nt': 'Northern Territory (NT)',
            'northern territory': 'Northern Territory (NT)'
          };
          
          const locationLower = locationString.toLowerCase();
          
          // Try to match state names
          for (const [key, stateName] of Object.entries(stateMap)) {
            if (locationLower.includes(key)) {
              return stateName;
            }
          }
          
          // If no match, try to extract middle part (usually state is in the middle)
          const parts = locationString.trim().split(/\s+/);
          if (parts.length >= 2) {
            // Return the middle part (likely the state)
            return parts[1];
          }
          
          return locationString; // Fallback
        };
        
        // Map locations: API returns locations with commas like "Aspley, Queensland, 4034"
        const tempData2 = locations.map((e, index) => {
          // Get full location string from API (with commas)
          const fullLocation = e?.name || e || '';
          
          // Extract state name from comma-separated format
          // Format is typically: "Suburb, State, PostalCode"
          const extractStateFromCommaFormat = (locationString) => {
            if (!locationString || typeof locationString !== 'string') return null;
            
            // Split by comma and get the middle part (state)
            const parts = locationString.split(',').map(p => p.trim()).filter(Boolean);
            
            // If we have at least 2 parts, the middle one(s) is usually the state
            if (parts.length >= 2) {
              // Usually format is: [suburb, state, postalCode]
              // State is typically the second part
              if (parts.length >= 3) {
                return parts[1]; // Return state (middle part)
              } else if (parts.length === 2) {
                // Could be "Suburb, State" or "State, PostalCode"
                // Check if second part is numeric (postal code)
                if (/^\d+$/.test(parts[1])) {
                  return parts[0]; // First part is state
                } else {
                  return parts[1]; // Second part is state
                }
              }
            }
            
            // Fallback: try to extract using the old method
            return extractStateName(e);
          };
          
          const stateName = extractStateFromCommaFormat(fullLocation) || extractStateName(e);
          
          // Use full location (with commas) as unique value for checkbox
          const uniqueValue = fullLocation || `location_${index}`;
          
          return {
            label: fullLocation, // Show location as-is from API (e.g., "Aspley, Queensland, 4034")
            value: uniqueValue, // Use full location string (with commas) as value for checkbox
            stateName: stateName, // Store extracted state name for filter building
          };
        });
        
        setData(tempData2);
      } else {
        const params = {
          limit: 20000,
          sort: 'name',
          type: item?.value,
          search: search,
        };
        const response = await API_MANAGER.getTagsBySearch(params);
        if (item?.value === "GENDER") {
          const tempData2 = response?.data?.data?.tags?.map((e) => {
            return {
              label: e?.name,
              value: e?.name,
            };
          });

          setData(tempData2);
        } else {
          const tempData = response?.data?.data?.tags?.map((e) => {
            return {
              label: e?.name,
              value: e?._id,
              // checked: false,
            };
          });

          setData(tempData);
        }
      }
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  useEffect(() => {
    getData();
  }, []);
  
  // Helper function to convert location format from "Aspley, Queensland, 4034" to "Aspley-Queensland-4034"
  const formatLocationForAPI = (locationString) => {
    if (!locationString || typeof locationString !== 'string') return '';
    
    // Split by comma and trim each part
    const parts = locationString.split(',').map(p => p.trim()).filter(Boolean);
    
    // If we have 3 parts (suburb, state, postcode), format as "Suburb-State-Postcode"
    if (parts.length >= 3) {
      return `${parts[0]}-${parts[1]}-${parts[2]}`;
    }
    // If we have 2 parts, assume "Suburb, State" or "State, Postcode"
    else if (parts.length === 2) {
      // Check if second part is numeric (postal code)
      if (/^\d+$/.test(parts[1])) {
        // Format: "State-Postcode" (if first part is state)
        return `${parts[0]}-${parts[1]}`;
      } else {
        // Format: "Suburb-State"
        return `${parts[0]}-${parts[1]}`;
      }
    }
    // Fallback: return as-is with spaces replaced by dashes
    return locationString.replace(/\s+/g, '-');
  };

  // Update selected count when filters change (duplicate removed - using the one above)
  const handleChange = (e) => {
    // For STATE filter, we need to store selected locations separately
    // and format them as "Suburb-State-Postcode" for the API filter
    if (item?.value === "STATE") {
      const locationStorageKey = `${item?.label}_locations`;
      let selectedLocations = [];
      
      const currentValue = (e?.target?.value || '').trim();
      
      if (e?.target?.checked) {
        // Use a special separator to avoid conflicts with commas in location names
        // We'll use a pipe separator for storing multiple locations
        const storedLocations = filters[locationStorageKey] 
          ? filters[locationStorageKey].split("|||").filter(Boolean)
          : [];
        
        if (!storedLocations.includes(currentValue)) {
          storedLocations.push(currentValue);
        }
        selectedLocations = storedLocations;
      } else {
        // Remove location from selected list
        const storedLocations = filters[locationStorageKey] 
          ? filters[locationStorageKey].split("|||").filter(Boolean)
          : [];
        selectedLocations = storedLocations.filter((value) => value !== currentValue);
      }
      
      setSelectedListCount(selectedLocations.length);
      
      // Format locations for API: convert "Aspley, Queensland, 4034" to "Aspley-Queensland-4034"
      const formattedLocations = selectedLocations.map(locationValue => {
        return formatLocationForAPI(locationValue);
      }).filter(Boolean);
      
      // Store both: locations for checkbox state (using ||| separator), formatted locations for API filter (comma-separated)
      const newFilters = {
        ...filters,
        [locationStorageKey]: selectedLocations.length > 0 ? selectedLocations.join("|||") : null,
        [item?.label]: formattedLocations.length > 0 ? formattedLocations.join(",") : null,
      };
      
      // Clean up location storage key if no selections
      if (selectedLocations.length === 0) {
        delete newFilters[locationStorageKey];
        delete newFilters[item?.label];
      }
      
      setFilters(newFilters);
    } else {
      // For other filters, use the original logic
      let tempFilter = [];
      if (e?.target?.checked) {
        tempFilter = filters[item?.label]?.split(",") ?? [];
        tempFilter = [...tempFilter, e?.target?.value];
        setSelectedListCount(tempFilter?.length);
        tempFilter = tempFilter.join(",");
      } else {
        tempFilter = filters[item?.label]?.split(",") ?? [];
        tempFilter = tempFilter?.filter((value) => value !== e?.target?.value);
        setSelectedListCount(tempFilter?.length);

        tempFilter = tempFilter.join(",");
      }

      setFilters({
        ...filters,
        [item?.label]: tempFilter?.length > 0 ? tempFilter : null,
      });
    }
    // default - true data
    // search -  false data
    // uncheck -  1 . default  - true data
    // 2. search - false data
    // search change

    //assumption - e always false , prev state always true
  };

  return (
    <div className="searchListItem">
      <Row
        justify={"space-between"}
        align={"middle"}
        className="cursor-pointer"
      >
        <Col xs={19} className="title" onClick={() => setExpand(!expand)}>
          {item?.name} {selectedListCount > 0 ? ` (${selectedListCount})` : ""}
        </Col>
        {expand && (
          <Col
            xs={1}
            className="resetButton"
            onClick={() => {
              const newFilters = { ...filters };
              newFilters[item?.label] = null;
              // Also clear location storage for STATE filter
              if (item?.value === "STATE") {
                delete newFilters[`${item?.label}_locations`];
              }
              setFilters(newFilters);
              setSelectedListCount(0);
            }}
          >
            <img src={CancelIcon} />
          </Col>
        )}
        <Col>
          <img
            className="cursor-pointer"
            onClick={() => setExpand(!expand)}
            src={DownArrow}
            alt="down"
          />
        </Col>
      </Row>
      {/* {expand && ( */}
      <div style={{ display: expand ? "block" : "none" }}>
        {item?.value !== "CITIZENSHIP" && (
          <Row>
            <Col xs={24}>
              <Input
                className="search-input"
                size="large"
                value={search}
                placeholder={`Search ${item?.name}`}
                onChange={(e) => setSearch(e?.target?.value)}
                suffix={
                  search && (
                    <img
                      src={CancelIcon}
                      className="cursor_pointer"
                      alt="cross"
                      onClick={() => {
                        setSearch(null);
                      }}
                    />
                  )
                }
                prefix={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M19.8947 19.0002L15.5517 14.6572M15.5517 14.6572C16.2946 13.9143 16.8839 13.0324 17.286 12.0618C17.688 11.0911 17.8949 10.0508 17.8949 9.00021C17.8949 7.9496 17.688 6.90929 17.286 5.93866C16.8839 4.96803 16.2946 4.08609 15.5517 3.34321C14.8088 2.60032 13.9269 2.01103 12.9563 1.60898C11.9857 1.20693 10.9453 1 9.89474 1C8.84414 1 7.80382 1.20693 6.83319 1.60898C5.86256 2.01103 4.98062 2.60032 4.23774 3.34321C2.73741 4.84354 1.89453 6.87842 1.89453 9.00021C1.89453 11.122 2.73741 13.1569 4.23774 14.6572C5.73807 16.1575 7.77295 17.0004 9.89474 17.0004C12.0165 17.0004 14.0514 16.1575 15.5517 14.6572Z"
                      stroke="#1638B1"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
              />
            </Col>
          </Row>
        )}

        <div className="checkBoxContainer">
          {/* <CheckboxGroup
              value={filters[item?.label]?.split(",")}
              options={data}
              className="searchCheckBoxGroup"
              onChange={(e) => handleChange(e)}
            /> */}

          {data?.map((e, index) => {
            // For STATE filter, check against stored locations; for others, check against filter values
            let isChecked = false;
            
            if (item?.value === "STATE") {
              const locationStorageKey = `${item?.label}_locations`;
              // Use ||| separator to avoid conflicts with commas in location names
              const storedLocations = filters[locationStorageKey] 
                ? filters[locationStorageKey].split("|||").filter(Boolean)
                : [];
              const currentValue = (e?.value || '').trim();
              isChecked = storedLocations.includes(currentValue);
            } else {
              const storedValues = (filters[item?.label]?.split(",") ?? []).filter(Boolean);
              isChecked = storedValues.includes(e?.value);
            }
            
            return (
              <div
                key={index}
                className="searchListItems"
                style={{
                  display: !search
                    ? "block"
                    : e?.label?.toLowerCase().includes(search?.toLowerCase())
                    ? "block"
                    : "none",
                }}
              >
                <Checkbox
                  hidden
                  value={e?.value}
                  checked={isChecked}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  className="checkBoxItem"
                >
                  {e?.label}
                </Checkbox>
              </div>
            );
          })}
        </div>
      </div>
      {/* )} */}
    </div>
  );
}

export default SearchListItem;
